import type { NextRouter } from "next/router"

export const debugEnabled = (router: NextRouter): boolean => {
  return process.env.NODE_ENV === `development` || router.query.debug === `true`
}
